import { GetBusinessInfoService, GetGeoLocationService, GetRatingShopService } from "../Infrastructure/Business.service";

export async function GetBusinessInfoLogic(id) {
    const response = await GetBusinessInfoService(id);
    if(response.schedule){
      try {
        let schedule_json = JSON.parse(response['schedule']);
         let schedule = [];
         schedule_json.forEach( day => {
          schedule.push(day['nombre'] + ': '+ day['inicio'] + ' - '+ day['fin']);
         });
         return {...response, schedule}
      } catch (error) {
        return {...response, schedule: "---"}
      }
    }else{
      return response
    }
}

export async function GetGeoLocationLogic(id){
  return GetGeoLocationService(id);
}

export async function GetRatingShopLogic(id){
  return GetRatingShopService(id);
}